module.exports = __webpack_public_path__ + "static/media/getInTouch.bce35297.svg";